import { useAsyncData } from 'shared/hooks/useAsyncData';
import { PLAYER_SPORT_LEVELS } from 'modules/jogador/profile/content';
import { fetchPlayerSportLevels } from 'modules/jogador/profile/profileService';

export function useProfile() {
  const { data: sportLevels, isLoading, error } = useAsyncData(fetchPlayerSportLevels, PLAYER_SPORT_LEVELS);
  return { sportLevels, isLoading, error };
}
